export const environment = {
  production: false,
  apiUrl: 'https://api-dev.lonniyire.fr/api',
  appName: 'Lonniyire',
  version: '1.0.0',
  logLevel: 'info',
  enableAnalytics: true,
  enableErrorReporting: true,
  cacheEnabled: true,
  requestTimeout: 30000,
};
